var React = require('react');

function SiteLogoDesktopFooter (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Woodward_Branding_Icons_PMS_109C"),React.createElement("g",{"key":1},[React.createElement("polygon",{"points":"150.47 0 136.09 88.99 115.02 0 75.28 0 54.25 89.12 39.89 0 0 0 30.24 159.18 71.42 159.18 95.17 58.96 103.2 92.71 172.39 92.67 190.16 0 150.47 0","style":{"fill":"#ffd100"},"key":0}),React.createElement("polygon",{"points":"152.39 130.79 145.54 97.85 130.18 97.85 123.34 130.84 118.68 97.85 104.6 97.85 114.82 159.18 129.44 159.18 137.87 118.65 140.72 132.3 142.54 141.03 146.33 159.18 160.95 159.18 163.88 141.4 165.31 132.73 171.08 97.85 157.06 97.85 152.39 130.79","style":{"fill":"#ffd100"},"key":1})])]);
}

SiteLogoDesktopFooter.defaultProps = {"role":"presentation","id":"ICON","viewBox":"0 0 190.16 159.18"};

module.exports = SiteLogoDesktopFooter;

SiteLogoDesktopFooter.default = SiteLogoDesktopFooter;
